import { useParams } from 'react-router-dom';
import { config } from "../../data/config";
import { useEffect } from 'react';
import { getCookies } from "cookies-next";
import { useCookies } from 'react-cookie';
import axios from "axios";
import { useState } from "react";
import BreadCrump from "../tools/breadcrump"
import { TagInput } from 'rsuite';

import * as React from 'react';
import TissEditor from '../Editor/TissEditor';
import ImageUploader from '../tools/uploaderImage';
import { useTranslation } from 'react-i18next';
import Swal from 'sweetalert2';
import { Button, Input, Tabs, SelectPicker } from 'rsuite';
import changeUrl from "../../hoc/changeur";
import HeaderOfPage from '../tools/headerOfPage';
import AutoTranslateButton from '../tools/AutoTranslateButton';
export default function EditProductsGroup() {
    const { t } = useTranslation();

    let cookie = getCookies();

    let { Id } = useParams();
    const [cookies, setCookie] = useCookies(['token', 'rule']);
    const [key, setKey] = useState<any>(1);
    const [error, setError] = useState<any>(null);
    const [loading, setLoading] = useState<boolean>(true);
    const [saving, setSaving] = useState<boolean>(false);
    const [savingFeature, setSavingFeature] = useState<boolean>(false);

    const [data, setData] = React.useState<any>(null);
    const [features, setFeatures] = useState<any[]>([]);
    const [featureForm, setFeatureForm] = useState<any>({
        id: null,
        name: { ku: '', fa: '', en: '', ar: '', tr: '' },
        type: 'textbox',
        searchable: true,
        options: [],
    });

    // Helper to get display name from multilingual or string
    const getDisplayName = (name: any): string => {
        if (!name) return '';
        if (typeof name === 'string') return name;
        if (typeof name === 'object') {
            return name[activeLang] || name.en || name.fa || name.ku || name.ar || name.tr || '';
        }
        return String(name);
    };
    const [activeLang, setActiveLang] = useState<string>('en');
    const languages = [
        { code: 'ku', label: 'Kurdish' },
        { code: 'fa', label: 'فارسی' },
        { code: 'en', label: 'English' },
        { code: 'ar', label: 'العربية' },
        { code: 'tr', label: 'Türkçe' }
    ];
    const save = async () => {
        setSaving(true);
        try {
            var path = `${config.url}/v1/dashboard/pgroup/${Id}`;

            let res = await axios({
                method: 'put',
                data: data,
                url: path,
                headers: {
                    Authorization: 'Bearer ' + cookie['token'],
                }
            });
            Swal.fire({
                icon: 'success',
                title: t('Success'),
                text: 'اطلاعات با موفقیت به‌روزرسانی شد',
                timer: 1500,
                showConfirmButton: false
            });
        } catch (error: any) {
            let errorMessage = 'خطا در به‌روزرسانی اطلاعات';
            if (error.response?.data?.message) {
                const msg = error.response.data.message;
                if (typeof msg === 'string') {
                    errorMessage = msg;
                } else if (typeof msg === 'object' && msg.message) {
                    errorMessage = typeof msg.message === 'string' ? msg.message : String(msg.message);
                }
            }
            Swal.fire({
                icon: 'error',
                title: t('Error'),
                text: errorMessage,
            });
        } finally {
            setSaving(false);
        }
    }
    const load = async () => {
        setLoading(true);
        try {
            var path = `${config.url}/v1/dashboard/pgroup/${Id}`;

            let res = await axios({
                method: 'get',
                url: path,
                headers: {
                    Authorization: 'Bearer ' + cookie['token'],
                }
            });
            const loadedData = res.data.message;
            // Ensure multilingual structure exists
            if (loadedData) {
                if (typeof loadedData.name === 'string') {
                    loadedData.name = { ku: loadedData.name, fa: loadedData.name, en: loadedData.name, ar: loadedData.name, tr: loadedData.name };
                } else if (loadedData.name && loadedData.name.nl) {
                    // Migrate old nl to ku
                    loadedData.name.ku = loadedData.name.nl;
                    delete loadedData.name.nl;
                    if (!loadedData.name.tr) loadedData.name.tr = '';
                }
                if (typeof loadedData.url === 'string' || !loadedData.url) {
                    loadedData.url = loadedData.url ? { ku: loadedData.url, fa: loadedData.url, en: loadedData.url, ar: loadedData.url, tr: loadedData.url } : { ku: '', fa: '', en: '', ar: '', tr: '' };
                } else if (loadedData.url && loadedData.url.nl) {
                    loadedData.url.ku = loadedData.url.nl;
                    delete loadedData.url.nl;
                    if (!loadedData.url.tr) loadedData.url.tr = '';
                }
                if (typeof loadedData.title === 'string' || !loadedData.title) {
                    loadedData.title = loadedData.title ? { ku: loadedData.title, fa: loadedData.title, en: loadedData.title, ar: loadedData.title, tr: loadedData.title } : { ku: '', fa: '', en: '', ar: '', tr: '' };
                } else if (loadedData.title && loadedData.title.nl) {
                    loadedData.title.ku = loadedData.title.nl;
                    delete loadedData.title.nl;
                    if (!loadedData.title.tr) loadedData.title.tr = '';
                }
                if (typeof loadedData.description === 'string' || !loadedData.description) {
                    loadedData.description = loadedData.description ? { ku: loadedData.description, fa: loadedData.description, en: loadedData.description, ar: loadedData.description, tr: loadedData.description } : { ku: '', fa: '', en: '', ar: '', tr: '' };
                } else if (loadedData.description && loadedData.description.nl) {
                    loadedData.description.ku = loadedData.description.nl;
                    delete loadedData.description.nl;
                    if (!loadedData.description.tr) loadedData.description.tr = '';
                }
                if (typeof loadedData.keywords === 'string' || !loadedData.keywords) {
                    loadedData.keywords = loadedData.keywords ? { ku: loadedData.keywords, fa: loadedData.keywords, en: loadedData.keywords, ar: loadedData.keywords, tr: loadedData.keywords } : { ku: '', fa: '', en: '', ar: '', tr: '' };
                } else if (loadedData.keywords && loadedData.keywords.nl) {
                    loadedData.keywords.ku = loadedData.keywords.nl;
                    delete loadedData.keywords.nl;
                    if (!loadedData.keywords.tr) loadedData.keywords.tr = '';
                }
                if (typeof loadedData.text === 'string' || !loadedData.text) {
                    loadedData.text = loadedData.text ? { ku: loadedData.text, fa: loadedData.text, en: loadedData.text, ar: loadedData.text, tr: loadedData.text } : { ku: '', fa: '', en: '', ar: '', tr: '' };
                } else if (loadedData.text && loadedData.text.nl) {
                    loadedData.text.ku = loadedData.text.nl;
                    delete loadedData.text.nl;
                    if (!loadedData.text.tr) loadedData.text.tr = '';
                }
            }
            setData(loadedData)
        } catch (error: any) {
            let errorMessage = 'خطا در بارگذاری اطلاعات';
            if (error.response?.data?.message) {
                errorMessage = typeof error.response.data.message === 'string'
                    ? error.response.data.message
                    : 'خطا در بارگذاری';
            }
            Swal.fire({
                icon: 'error',
                title: t('Error'),
                text: errorMessage,
            });
        } finally {
            setLoading(false);
        }
    }
    const loadFeatures = async () => {
        try {
            const path = `${config.url}/v1/dashboard/productsfeature?productGroupId=${Id}`;
            const res = await axios({
                method: 'get',
                url: path,
                headers: {
                    Authorization: 'Bearer ' + cookie['token'],
                }
            });
            // Normalize feature names to multilingual structure
            const normalizedFeatures = (res.data.message || []).map((feature: any) => {
                // Create a new object to avoid mutation
                const normalizedFeature: any = { ...feature };

                // Normalize name
                if (normalizedFeature.name && typeof normalizedFeature.name === 'string') {
                    normalizedFeature.name = {
                        ku: normalizedFeature.name,
                        fa: normalizedFeature.name,
                        en: normalizedFeature.name,
                        ar: normalizedFeature.name,
                        tr: normalizedFeature.name
                    };
                } else if (normalizedFeature.name && typeof normalizedFeature.name === 'object' && normalizedFeature.name.nl) {
                    // Migrate old nl to ku
                    normalizedFeature.name = {
                        ...normalizedFeature.name,
                        ku: normalizedFeature.name.nl,
                        tr: normalizedFeature.name.tr || ''
                    };
                    delete normalizedFeature.name.nl;
                }

                // Normalize options to multilingual structure with IDs
                if (normalizedFeature.options && Array.isArray(normalizedFeature.options)) {
                    normalizedFeature.options = normalizedFeature.options.map((opt: any, idx: number) => {
                        if (typeof opt === 'string') {
                            // Legacy: convert string to object with id and multilingual name
                            return {
                                id: `opt_${normalizedFeature._id}_${idx}_${Date.now()}`,
                                name: { ku: opt, fa: opt, en: opt, ar: opt, tr: opt }
                            };
                        } else if (opt && typeof opt === 'object') {
                            // Create a new object to avoid mutation
                            const normalizedOpt: any = { ...opt };

                            // Ensure id exists
                            if (!normalizedOpt.id) {
                                normalizedOpt.id = `opt_${normalizedFeature._id}_${idx}_${Date.now()}`;
                            }

                            // Ensure multilingual name structure
                            if (typeof normalizedOpt.name === 'string') {
                                normalizedOpt.name = {
                                    ku: normalizedOpt.name,
                                    fa: normalizedOpt.name,
                                    en: normalizedOpt.name,
                                    ar: normalizedOpt.name,
                                    tr: normalizedOpt.name
                                };
                            } else if (!normalizedOpt.name || typeof normalizedOpt.name !== 'object') {
                                normalizedOpt.name = { ku: '', fa: '', en: '', ar: '', tr: '' };
                            } else {
                                // Ensure all language fields exist
                                normalizedOpt.name = {
                                    ku: normalizedOpt.name.ku || '',
                                    fa: normalizedOpt.name.fa || '',
                                    en: normalizedOpt.name.en || '',
                                    ar: normalizedOpt.name.ar || '',
                                    tr: normalizedOpt.name.tr || ''
                                };
                            }
                            return normalizedOpt;
                        }
                        return opt;
                    });
                } else {
                    // Ensure options is an array
                    normalizedFeature.options = [];
                }

                return normalizedFeature;
            });
            console.log('loadFeatures - Normalized features:', JSON.parse(JSON.stringify(normalizedFeatures)));
            setFeatures(normalizedFeatures);
        } catch (error) {
            console.error('Error loading features:', error);
        }
    }

    const resetFeatureForm = () => {
        setFeatureForm({
            id: null,
            name: { ku: '', fa: '', en: '', ar: '', tr: '' },
            type: 'textbox',
            searchable: true,
            options: [],
        });
    };

    // Helper to generate unique ID for options
    const generateOptionId = () => {
        return `opt_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`;
    };

    // Add new option
    const addOption = () => {
        const newOption = {
            id: generateOptionId(),
            name: { ku: '', fa: '', en: '', ar: '', tr: '' }
        };
        const updatedOptions = [...(featureForm.options || []), newOption];
        setFeatureForm({
            ...featureForm,
            options: updatedOptions
        });
    };

    // Update option name
    const updateOptionName = (optionId: string | undefined, lang: string, value: string) => {
        if (!optionId) {
            console.error('updateOptionName called without optionId');
            return;
        }
        const updatedOptions = (featureForm.options || []).map((opt: any) => {
            // Match by id, or if id doesn't exist, match by index
            if (opt.id === optionId) {
                return {
                    ...opt,
                    id: opt.id || generateOptionId(), // Ensure id exists
                    name: {
                        ...(opt.name || { ku: '', fa: '', en: '', ar: '', tr: '' }),
                        [lang]: value
                    }
                };
            }
            return opt;
        });
        setFeatureForm({
            ...featureForm,
            options: updatedOptions
        });
    };

    // Remove option
    const removeOption = (optionId: string | undefined) => {
        if (!optionId) {
            console.error('removeOption called without optionId');
            return;
        }
        setFeatureForm({
            ...featureForm,
            options: (featureForm.options || []).filter((opt: any) => opt.id !== optionId)
        });
    };

    const saveFeature = async () => {
        setSavingFeature(true);
        try {
            const baseUrl = `${config.url}/v1/dashboard/productsfeature`;

            // Validate that at least one language has a name
            const hasName = featureForm.name && (
                featureForm.name.ku ||
                featureForm.name.fa ||
                featureForm.name.en ||
                featureForm.name.ar ||
                featureForm.name.tr
            );

            if (!hasName) {
                Swal.fire({
                    icon: 'warning',
                    title: 'هشدار',
                    text: 'نام ویژگی را حداقل برای یک زبان وارد کنید'
                });
                return;
            }

            // Prepare options - filter out empty options and ensure structure
            let preparedOptions: any[] = [];
            if (featureForm.type === 'list') {
                // Always process options for list type
                if (featureForm.options && Array.isArray(featureForm.options) && featureForm.options.length > 0) {
                    preparedOptions = featureForm.options
                        .filter((opt: any) => {
                            // Keep option if it has at least one language with a name
                            if (!opt) return false;
                            if (!opt.name) return false;
                            // Check if name is object with multilingual structure
                            if (typeof opt.name === 'object') {
                                const hasAnyName = opt.name.ku || opt.name.fa || opt.name.en || opt.name.ar || opt.name.tr;
                                return hasAnyName;
                            }
                            // Legacy: if name is string, keep it
                            if (typeof opt.name === 'string' && opt.name.trim()) {
                                return true;
                            }
                            return false;
                        })
                        .map((opt: any) => {
                            // Ensure proper structure with id
                            const optId = opt.id || generateOptionId();
                            if (typeof opt.name === 'string') {
                                // Convert string name to multilingual
                                return {
                                    id: optId,
                                    name: { ku: opt.name, fa: opt.name, en: opt.name, ar: opt.name, tr: opt.name }
                                };
                            }
                            return {
                                id: optId,
                                name: opt.name || { ku: '', fa: '', en: '', ar: '', tr: '' }
                            };
                        });
                }
            }

            const payload: any = {
                name: featureForm.name,
                productGroupId: Id,
                type: featureForm.type,
                searchable: featureForm.searchable,
            };

            // Always include options field for list type
            if (featureForm.type === 'list') {
                payload.options = preparedOptions;
            }


            if (featureForm.id) {
                await axios({
                    method: 'put',
                    url: `${baseUrl}/${featureForm.id}`,
                    data: payload,
                    headers: {
                        Authorization: 'Bearer ' + cookie['token'],
                    }
                });
                Swal.fire({
                    icon: 'success',
                    title: 'موفق',
                    text: 'ویژگی با موفقیت ویرایش شد',
                    timer: 1500,
                    showConfirmButton: false
                });
            } else {
                await axios({
                    method: 'post',
                    url: baseUrl,
                    data: payload,
                    headers: {
                        Authorization: 'Bearer ' + cookie['token'],
                    }
                });
                Swal.fire({
                    icon: 'success',
                    title: 'موفق',
                    text: 'ویژگی با موفقیت اضافه شد',
                    timer: 1500,
                    showConfirmButton: false
                });
            }

            await loadFeatures();
            resetFeatureForm();
        } catch (error: any) {
            let errorMessage = 'خطا در ذخیره ویژگی';
            if (error.response?.data?.message) {
                const msg = error.response.data.message;
                if (typeof msg === 'string') {
                    errorMessage = msg;
                } else if (typeof msg === 'object' && msg.message) {
                    errorMessage = typeof msg.message === 'string' ? msg.message : String(msg.message);
                }
            }
            Swal.fire({
                icon: 'error',
                title: t('Error'),
                text: errorMessage,
            });
        } finally {
            setSavingFeature(false);
        }
    };

    const editFeature = (item: any) => {
        // Find the feature from state to ensure we have the latest data including options
        console.log('editFeature - Starting, features count:', features.length);
        console.log('editFeature - Item ID:', item._id || item.id);

        const featureFromState = features.find((f: any) => {
            const match = (f._id === item._id) || (f.id === item._id) || (f._id === item.id) || (f.id === item.id);
            if (match) {
                console.log('editFeature - Found matching feature:', f._id || f.id, 'with options:', f.options);
            }
            return match;
        });

        const featureToEdit = featureFromState || item;

        console.log('editFeature - All features in state:', JSON.parse(JSON.stringify(features)));
        console.log('editFeature - Item from click:', JSON.parse(JSON.stringify(item)));
        console.log('editFeature - Item ID to find:', item._id || item.id);
        console.log('editFeature - Feature from state found?', !!featureFromState);
        console.log('editFeature - Feature from state:', JSON.parse(JSON.stringify(featureFromState)));
        console.log('editFeature - Feature from state options:', featureFromState?.options);
        console.log('editFeature - Using feature:', JSON.parse(JSON.stringify(featureToEdit)));
        console.log('editFeature - Using feature options:', featureToEdit.options);

        // Normalize name to multilingual structure
        let normalizedName = featureToEdit.name;
        if (typeof normalizedName === 'string') {
            normalizedName = {
                ku: normalizedName,
                fa: normalizedName,
                en: normalizedName,
                ar: normalizedName,
                tr: normalizedName
            };
        } else if (normalizedName && typeof normalizedName === 'object' && normalizedName.nl) {
            normalizedName = {
                ...normalizedName,
                ku: normalizedName.nl,
            };
            delete normalizedName.nl;
            if (!normalizedName.tr) normalizedName.tr = '';
        } else if (!normalizedName || typeof normalizedName !== 'object') {
            normalizedName = { ku: '', fa: '', en: '', ar: '', tr: '' };
        }

        // Normalize options to multilingual structure
        let normalizedOptions: any[] = [];
        console.log('editFeature - Original options from feature:', JSON.parse(JSON.stringify(featureToEdit.options || [])));
        console.log('editFeature - Options type:', typeof featureToEdit.options);
        console.log('editFeature - Is array?', Array.isArray(featureToEdit.options));
        console.log('editFeature - Options length:', featureToEdit.options?.length);
        console.log('editFeature - Full feature object:', JSON.parse(JSON.stringify(featureToEdit)));

        // Check if options exist and are valid
        if (featureToEdit.options && Array.isArray(featureToEdit.options)) {
            console.log('editFeature - Processing options array with length:', featureToEdit.options.length);
            normalizedOptions = featureToEdit.options.map((opt: any, idx: number) => {
                console.log(`editFeature - Processing option ${idx}:`, JSON.parse(JSON.stringify(opt)));
                if (typeof opt === 'string') {
                    // Legacy: convert string to object with id and multilingual name
                    return {
                        id: generateOptionId(),
                        name: { ku: opt, fa: opt, en: opt, ar: opt, tr: opt }
                    };
                } else if (opt && typeof opt === 'object') {
                    // Create a new object to avoid mutation
                    const normalizedOpt: any = {
                        id: opt.id || generateOptionId(),
                        name: opt.name ? { ...opt.name } : { ku: '', fa: '', en: '', ar: '', tr: '' }
                    };

                    // Ensure multilingual name structure
                    if (typeof normalizedOpt.name === 'string') {
                        normalizedOpt.name = {
                            ku: normalizedOpt.name,
                            fa: normalizedOpt.name,
                            en: normalizedOpt.name,
                            ar: normalizedOpt.name,
                            tr: normalizedOpt.name
                        };
                    } else if (!normalizedOpt.name || typeof normalizedOpt.name !== 'object') {
                        normalizedOpt.name = { ku: '', fa: '', en: '', ar: '', tr: '' };
                    } else {
                        // Ensure all language fields exist
                        normalizedOpt.name = {
                            ku: normalizedOpt.name.ku || '',
                            fa: normalizedOpt.name.fa || '',
                            en: normalizedOpt.name.en || '',
                            ar: normalizedOpt.name.ar || '',
                            tr: normalizedOpt.name.tr || ''
                        };
                    }
                    return normalizedOpt;
                }
                return opt;
            });
        } else {
            // If no options, set empty array
            normalizedOptions = [];
        }

        console.log('editFeature - Normalized options:', JSON.parse(JSON.stringify(normalizedOptions)));

        const formData = {
            id: featureToEdit._id || featureToEdit.id,
            name: normalizedName,
            type: featureToEdit.type ?? 'textbox',
            searchable: featureToEdit.searchable ?? true,
            options: normalizedOptions,
        };

        console.log('editFeature - Setting form data:', JSON.parse(JSON.stringify(formData)));

        setFeatureForm(formData);
    };

    const deleteFeature = async (id: string) => {
        try {
            const confirm = await Swal.fire({
                title: 'حذف ویژگی',
                text: 'آیا از حذف این ویژگی مطمئن هستید؟',
                icon: 'warning',
                showCancelButton: true,
                confirmButtonText: 'بله',
                cancelButtonText: 'خیر',
            });

            if (!confirm.isConfirmed) return;

            const baseUrl = `${config.url}/v1/dashboard/productsfeature`;
            await axios({
                method: 'delete',
                url: `${baseUrl}/${id}`,
                headers: {
                    Authorization: 'Bearer ' + cookie['token'],
                }
            });
            Swal.fire('ویژگی حذف شد');
            await loadFeatures();
        } catch (error) {

        }
    };
    const breadcrump = [
        {
            name: 'Dashboard',
            url: '/dashboard'
        },
        {
            name: 'Products',
            url: '/dashboard/ProductsGroup'
        },
        {
            name: 'Products List',
            url: '/dashboard/Products/ProductsGroup'
        },
        {
            name: 'Edit Group Products',
            url: null
        }
    ]
    useEffect(() => {
        load();
        loadFeatures();
    }, []);

    // Debug: Log featureForm changes
    useEffect(() => {
        if (featureForm.id) {
            console.log('Feature Form Updated:', {
                id: featureForm.id,
                type: featureForm.type,
                optionsCount: featureForm.options?.length || 0,
                options: featureForm.options
            });
        }
    }, [featureForm]);

    const inputstyle = "py-3 px-5 block w-full border border-gray-300 rounded-lg text-sm focus:ring-2 focus:ring-blue-500 focus:border-blue-500 disabled:opacity-50 disabled:pointer-events-none bg-white text-gray-900";

    if (loading) {
        return (
            <div className="bg-gray-50 min-h-screen p-4 md:p-6">
                <BreadCrump data={breadcrump}></BreadCrump>
                <HeaderOfPage name="ویرایش گروه محصول"></HeaderOfPage>
                <div className="bg-white rounded-xl shadow-sm p-8 mt-6">
                    <div className="flex items-center justify-center">
                        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600"></div>
                    </div>
                    <p className="text-center mt-4 text-gray-600">در حال بارگذاری...</p>
                </div>
            </div>
        );
    }

    return (
        <div className="bg-gray-50 min-h-screen p-4 md:p-6">
            <BreadCrump data={breadcrump}></BreadCrump>
            <HeaderOfPage name="ویرایش گروه محصول"></HeaderOfPage>

            {data != null && (
                <div className="mt-6">
                    <div className="bg-white rounded-xl shadow-sm overflow-hidden" dir='rtl'>
                        <Tabs defaultActiveKey="1" appearance="pills">
                            <Tabs.Tab eventKey="1" title="اطلاعات عمومی">
                                <div className="p-6 space-y-6">
                                    <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
                                        {/* Thumbnail */}
                                        <div className="bg-gray-50 border border-gray-200 rounded-xl p-4 flex flex-col gap-3">
                                            <div>
                                                <h3 className="text-sm font-semibold text-gray-800 mb-1">
                                                    تصویر گروه محصول
                                                </h3>
                                                <p className="text-xs text-gray-500">
                                                    تصویر شاخص برای نمایش این گروه در صفحات مختلف سایت.
                                                </p>
                                            </div>
                                            <div className="border-2 border-dashed border-gray-300 rounded-lg p-4 bg-white">
                                                <ImageUploader id={data.id} component={'PGroup'}></ImageUploader>
                                            </div>
                                        </div>

                                        {/* Form */}
                                        <div className="lg:col-span-2">
                                            <form key={key} className='flex flex-col gap-6'>
                                                {/* Language Selector */}
                                                <div className="bg-gray-50 border border-gray-200 rounded-xl p-4">
                                                    <label className="block text-sm font-medium text-gray-700 mb-3">
                                                        زبان / Language
                                                    </label>
                                                    <div className="flex gap-2 flex-wrap">
                                                        {languages.map((lang) => (
                                                            <button
                                                                key={lang.code}
                                                                type="button"
                                                                onClick={() => setActiveLang(lang.code)}
                                                                className={`px-4 py-2 text-sm font-medium rounded-lg transition-all duration-200 ${activeLang === lang.code
                                                                    ? 'bg-blue-600 text-white shadow-md scale-105'
                                                                    : 'bg-white text-gray-700 hover:bg-gray-100 border border-gray-200'
                                                                    }`}
                                                            >
                                                                {lang.label}
                                                            </button>
                                                        ))}
                                                    </div>
                                                </div>

                                                <div className="bg-gray-50 border border-gray-200 rounded-xl p-4 space-y-4">
                                                    <div className="flex items-center justify-between mb-2">
                                                        <h3 className="text-sm font-semibold text-gray-800">اطلاعات پایه</h3>
                                                        <span className="text-xs text-gray-400">الزامی</span>
                                                    </div>

                                                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                                                        <div>
                                                            <div className="flex items-center justify-between mb-1">
                                                                <label className="block text-sm font-medium text-gray-700">
                                                                    {t('Name')} ({languages.find(l => l.code === activeLang)?.label}) <span className="text-red-500">*</span>
                                                                </label>
                                                                <AutoTranslateButton
                                                                    sourceText={data.name?.en || ''}
                                                                    targetLang={activeLang}
                                                                    onTranslated={(text) => {
                                                                        const slugValue = String(changeUrl(text));
                                                                        setData({ ...data, name: { ...data.name, [activeLang]: text }, url: { ...data.url, [activeLang]: slugValue } });
                                                                    }}
                                                                />
                                                            </div>
                                                            <input
                                                                value={data.name?.[activeLang] || ''}
                                                                type="text"
                                                                className={`${inputstyle} ${error != null && error['name'] != undefined ? 'border-red-300 bg-red-50' : ''}`}
                                                                placeholder="نام گروه محصول را وارد کنید"
                                                                onChange={(e) => {
                                                                    const nameValue = e.target.value;
                                                                    const slugValue = String(changeUrl(nameValue));
                                                                    setData({
                                                                        ...data,
                                                                        name: {
                                                                            ...data.name,
                                                                            [activeLang]: nameValue
                                                                        },
                                                                        url: {
                                                                            ...data.url,
                                                                            [activeLang]: slugValue
                                                                        }
                                                                    });
                                                                }}
                                                            />
                                                            {error != null && error['name'] != undefined && (
                                                                <small className="text-red-500 text-xs mt-1 block">{error['name']['message']}</small>
                                                            )}
                                                        </div>

                                                        <div>
                                                            <label className="block text-sm font-medium text-gray-700 mb-1">
                                                                Code <span className="text-red-500">*</span>
                                                            </label>
                                                            <input
                                                                type="text"
                                                                value={data.code || ''}
                                                                className={`${inputstyle} ${error != null && error['code'] != undefined ? 'border-red-300 bg-red-50' : ''}`}
                                                                placeholder="مثال: CAT001"
                                                                onChange={(e) => setData({ ...data, code: e.target.value })}
                                                            />
                                                            {error != null && error['code'] != undefined && (
                                                                <small className="text-red-500 text-xs mt-1 block">{error['code']['message']}</small>
                                                            )}
                                                            <p className="mt-1 text-xs text-gray-400">
                                                                کد یکتای گروه (به انگلیسی و بدون فاصله).
                                                            </p>
                                                        </div>
                                                    </div>

                                                    <div>
                                                        <label className="block text-sm font-medium text-gray-700 mb-1">
                                                            Slug ({languages.find(l => l.code === activeLang)?.label})
                                                        </label>
                                                        <input
                                                            type="text"
                                                            value={data.url?.[activeLang] || ''}
                                                            className={`${inputstyle} ${error != null && error['url'] != undefined ? 'border-red-300 bg-red-50' : ''}`}
                                                            placeholder="مثال: category-name"
                                                            onChange={(e) => setData({
                                                                ...data,
                                                                url: {
                                                                    ...data.url,
                                                                    [activeLang]: e.target.value
                                                                }
                                                            })}
                                                        />
                                                        {error != null && error['url'] != undefined && (
                                                            <small className="text-red-500 text-xs mt-1 block">{error['url']['message']}</small>
                                                        )}
                                                        <p className="mt-1 text-xs text-gray-400">
                                                            آدرس گروه در سایت (به انگلیسی و بدون فاصله).
                                                        </p>
                                                    </div>
                                                </div>

                                                <div className="flex justify-end pt-2 border-t border-gray-200">
                                                    <Button
                                                        appearance="primary"
                                                        onClick={() => save()}
                                                        disabled={saving}
                                                        className="px-6"
                                                    >
                                                        {saving ? (
                                                            <>
                                                                <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-white mr-2 inline-block"></div>
                                                                در حال ذخیره...
                                                            </>
                                                        ) : (
                                                            <>
                                                                <svg className="w-4 h-4 mr-2 inline-block" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                                                                </svg>
                                                                ذخیره اطلاعات
                                                            </>
                                                        )}
                                                    </Button>
                                                </div>
                                            </form>
                                        </div>
                                    </div>
                                </div>
                            </Tabs.Tab>

                            <Tabs.Tab eventKey="2" title="متن">
                                <div className="p-6">
                                    <TissEditor component='PGroup' parent={data.id} />
                                </div>
                            </Tabs.Tab>

                            <Tabs.Tab eventKey="3" title="ویژگی ها">
                                <div className="flex flex-col gap-6">
                                    {/* Add/Edit Feature Form Card */}
                                    <div className="bg-gradient-to-br from-blue-50 to-indigo-50 rounded-xl border border-blue-200 p-6 shadow-sm">
                                        <div className="flex items-center justify-between mb-6">
                                            <h3 className="text-lg font-bold text-gray-800">
                                                {featureForm.id ? '✏️ ویرایش ویژگی' : '➕ افزودن ویژگی جدید'}
                                            </h3>
                                            {featureForm.id && (
                                                <button
                                                    onClick={resetFeatureForm}
                                                    className="text-sm text-gray-500 hover:text-gray-700 transition-colors"
                                                >
                                                    ✕ انصراف
                                                </button>
                                            )}
                                        </div>

                                        {/* Language Selector */}
                                        <div className="mb-6">
                                            <label className="block text-sm font-semibold text-gray-700 mb-3">
                                                🌐 زبان / Language
                                            </label>
                                            <div className="flex gap-2 flex-wrap">
                                                {languages.map((lang) => (
                                                    <button
                                                        key={lang.code}
                                                        type="button"
                                                        onClick={() => setActiveLang(lang.code)}
                                                        className={`px-4 py-2 text-sm font-medium rounded-lg transition-all duration-200 ${activeLang === lang.code
                                                            ? 'bg-blue-600 text-white shadow-md scale-105'
                                                            : 'bg-white text-gray-700 hover:bg-blue-50 hover:shadow-sm border border-gray-200'
                                                            }`}
                                                    >
                                                        {lang.label}
                                                    </button>
                                                ))}
                                            </div>
                                        </div>

                                        {/* Feature Form Fields */}
                                        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
                                            <div className="md:col-span-2">
                                                <div className="flex items-center justify-between mb-2">
                                                    <label className="block text-sm font-semibold text-gray-700">
                                                        📝 نام ویژگی ({languages.find(l => l.code === activeLang)?.label})
                                                    </label>
                                                    <AutoTranslateButton
                                                        sourceText={featureForm.name?.en || ''}
                                                        targetLang={activeLang}
                                                        onTranslated={(text) => setFeatureForm({
                                                            ...featureForm,
                                                            name: {
                                                                ...featureForm.name,
                                                                [activeLang]: text
                                                            }
                                                        })}
                                                    />
                                                </div>
                                                <Input
                                                    value={featureForm.name?.[activeLang] || ''}
                                                    className={`${inputstyle} bg-white`}
                                                    onChange={(value) => setFeatureForm({
                                                        ...featureForm,
                                                        name: {
                                                            ...featureForm.name,
                                                            [activeLang]: value || ''
                                                        }
                                                    })}
                                                    placeholder="مثال: رنگ، سایز، برند..."
                                                />
                                            </div>
                                            <div>
                                                <label className="block text-sm font-semibold text-gray-700 mb-2">
                                                    🎨 نوع ورودی
                                                </label>
                                                <SelectPicker
                                                    data={[
                                                        { label: '📄 Textbox', value: 'textbox' },
                                                        { label: '🔢 Number', value: 'number' },
                                                        { label: '☑️ Checkbox', value: 'checkbox' },
                                                        { label: '📋 List', value: 'list' },
                                                    ]}
                                                    value={featureForm.type}
                                                    onChange={(value) => setFeatureForm({ ...featureForm, type: value, options: value === 'list' ? (featureForm.options || []) : [] })}
                                                    className="w-full"
                                                    placeholder="انتخاب نوع"
                                                />
                                            </div>
                                            <div className="flex items-end">
                                                <div className="w-full bg-white rounded-lg border border-gray-200 p-4 flex items-center gap-3">
                                                    <input
                                                        id="searchable"
                                                        type="checkbox"
                                                        checked={featureForm.searchable}
                                                        onChange={(e) => setFeatureForm({ ...featureForm, searchable: e.target.checked })}
                                                        className="w-5 h-5 text-blue-600 rounded focus:ring-blue-500"
                                                    />
                                                    <label htmlFor="searchable" className="text-sm font-medium text-gray-700 cursor-pointer">
                                                        🔍 قابل جستجو در فیلترها
                                                    </label>
                                                </div>
                                            </div>
                                        </div>

                                        {/* Options Field */}
                                        {featureForm.type === 'list' && (
                                            <div className="mb-4 bg-white rounded-lg border border-gray-200 p-4">
                                                <div className="flex items-center justify-between mb-3">
                                                    <label className="block text-sm font-semibold text-gray-700">
                                                        🏷️ گزینه‌ها ({languages.find(l => l.code === activeLang)?.label})
                                                        {process.env.NODE_ENV === 'development' && (
                                                            <span className="ml-2 text-xs text-gray-400">
                                                                ({featureForm.options?.length || 0} گزینه)
                                                            </span>
                                                        )}
                                                    </label>
                                                    <Button
                                                        size="sm"
                                                        appearance="primary"
                                                        onClick={addOption}
                                                        style={{ backgroundColor: '#10b981' }}
                                                    >
                                                        ➕ افزودن گزینه
                                                    </Button>
                                                </div>

                                                {/* Debug info */}
                                                {process.env.NODE_ENV === 'development' && (
                                                    <div className="mb-2 p-2 bg-yellow-50 rounded text-xs">
                                                        <div>Type: {featureForm.type}</div>
                                                        <div>Options: {JSON.stringify(featureForm.options || [])}</div>
                                                    </div>
                                                )}

                                                <div className="space-y-3">
                                                    {(featureForm.options || []).map((option: any, index: number) => {
                                                        // Use index as fallback key, but ensure option has id for operations
                                                        const optionId = option.id || `temp_${index}`;

                                                        return (
                                                            <div key={optionId} className="flex gap-2 items-center bg-gray-50 rounded-lg p-3 border border-gray-200">
                                                                <div className="flex-1">
                                                                    <Input
                                                                        value={option.name?.[activeLang] || ''}
                                                                        className={inputstyle}
                                                                        onChange={(value) => {
                                                                            // If option doesn't have id, generate one first
                                                                            if (!option.id) {
                                                                                const newId = generateOptionId();
                                                                                const updatedOptions = (featureForm.options || []).map((opt: any, idx: number) =>
                                                                                    idx === index ? { ...opt, id: newId, name: { ...(opt.name || { ku: '', fa: '', en: '', ar: '', tr: '' }), [activeLang]: value || '' } } : opt
                                                                                );
                                                                                setFeatureForm({
                                                                                    ...featureForm,
                                                                                    options: updatedOptions
                                                                                });
                                                                            } else {
                                                                                updateOptionName(option.id, activeLang, value || '');
                                                                            }
                                                                        }}
                                                                        placeholder={`نام گزینه (${languages.find(l => l.code === activeLang)?.label})...`}
                                                                    />
                                                                </div>
                                                                <Button
                                                                    size="sm"
                                                                    color="red"
                                                                    appearance="primary"
                                                                    onClick={() => {
                                                                        if (option.id) {
                                                                            removeOption(option.id);
                                                                        } else {
                                                                            // Remove by index if no id
                                                                            setFeatureForm({
                                                                                ...featureForm,
                                                                                options: (featureForm.options || []).filter((_: any, idx: number) => idx !== index)
                                                                            });
                                                                        }
                                                                    }}
                                                                >
                                                                    🗑️
                                                                </Button>
                                                            </div>
                                                        );
                                                    })}
                                                    {(!featureForm.options || featureForm.options.length === 0) && (
                                                        <div className="text-center py-4 text-gray-400 text-sm">
                                                            هیچ گزینه‌ای اضافه نشده است. روی دکمه "افزودن گزینه" کلیک کنید.
                                                        </div>
                                                    )}
                                                </div>

                                                <p className="mt-3 text-xs text-gray-500 flex items-center gap-1">
                                                    💡 برای هر گزینه، نام را به زبان‌های مختلف وارد کنید
                                                </p>
                                            </div>
                                        )}

                                        {/* Action Buttons */}
                                        <div className="flex gap-3 pt-4 border-t border-blue-200">
                                            <Button
                                                appearance="primary"
                                                onClick={saveFeature}
                                                disabled={savingFeature}
                                                className="flex-1 md:flex-none px-6"
                                                style={{ backgroundColor: '#2563eb' }}
                                            >
                                                {savingFeature ? (
                                                    <>
                                                        <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-white mr-2 inline-block"></div>
                                                        در حال ذخیره...
                                                    </>
                                                ) : (
                                                    <>
                                                        {featureForm.id ? '💾 ذخیره تغییرات' : '➕ افزودن ویژگی'}
                                                    </>
                                                )}
                                            </Button>
                                            {featureForm.id && (
                                                <Button
                                                    appearance="subtle"
                                                    onClick={resetFeatureForm}
                                                    disabled={savingFeature}
                                                    className="px-6"
                                                >
                                                    ❌ انصراف
                                                </Button>
                                            )}
                                        </div>
                                    </div>

                                    {/* Features List */}
                                    <div className="mt-4">
                                        <div className="flex items-center justify-between mb-4">
                                            <h3 className="text-lg font-bold text-gray-800">
                                                📋 لیست ویژگی‌ها ({features.length})
                                            </h3>
                                        </div>

                                        {features.length === 0 ? (
                                            <div className="bg-gray-50 border-2 border-dashed border-gray-300 rounded-xl p-12 text-center">
                                                <div className="text-4xl mb-3">📭</div>
                                                <p className="text-gray-500 text-lg font-medium">هیچ ویژگی‌ای ثبت نشده است</p>
                                                <p className="text-gray-400 text-sm mt-1">برای شروع، یک ویژگی جدید اضافه کنید</p>
                                            </div>
                                        ) : (
                                            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                                                {features.map((item: any) => {
                                                    const typeLabels: Record<string, string> = {
                                                        'textbox': '📄 Textbox',
                                                        'number': '🔢 Number',
                                                        'checkbox': '☑️ Checkbox',
                                                        'list': '📋 List'
                                                    };
                                                    const typeColors: Record<string, string> = {
                                                        'textbox': 'bg-blue-100 text-blue-700',
                                                        'number': 'bg-green-100 text-green-700',
                                                        'checkbox': 'bg-purple-100 text-purple-700',
                                                        'list': 'bg-orange-100 text-orange-700'
                                                    };

                                                    return (
                                                        <div
                                                            key={item._id}
                                                            className="bg-white rounded-xl border border-gray-200 p-5 shadow-sm hover:shadow-md transition-all duration-200 hover:border-blue-300"
                                                        >
                                                            <div className="flex items-start justify-between mb-3">
                                                                <div className="flex-1">
                                                                    <h4 className="text-base font-bold text-gray-800 mb-2">
                                                                        {getDisplayName(item.name)}
                                                                    </h4>
                                                                    <div className="flex items-center gap-2 flex-wrap">
                                                                        <span className={`px-3 py-1 rounded-full text-xs font-semibold ${typeColors[item.type] || 'bg-gray-100 text-gray-700'}`}>
                                                                            {typeLabels[item.type] || item.type}
                                                                        </span>
                                                                        {item.searchable && (
                                                                            <span className="px-3 py-1 rounded-full text-xs font-semibold bg-yellow-100 text-yellow-700">
                                                                                🔍 قابل جستجو
                                                                            </span>
                                                                        )}
                                                                    </div>
                                                                </div>
                                                            </div>

                                                            {item.type === 'list' && item.options && Array.isArray(item.options) && item.options.length > 0 && (
                                                                <div className="mb-3 pt-3 border-t border-gray-100">
                                                                    <p className="text-xs font-semibold text-gray-500 mb-2">🏷️ گزینه‌ها:</p>
                                                                    <div className="flex flex-wrap gap-2">
                                                                        {item.options.map((opt: any, idx: number) => {
                                                                            const optName = typeof opt === 'string'
                                                                                ? opt
                                                                                : (opt?.name && typeof opt.name === 'object'
                                                                                    ? getDisplayName(opt.name)
                                                                                    : opt?.name || '');
                                                                            return (
                                                                                <span
                                                                                    key={opt?.id || idx}
                                                                                    className="px-2 py-1 bg-gray-100 text-gray-700 rounded-md text-xs"
                                                                                >
                                                                                    {optName}
                                                                                </span>
                                                                            );
                                                                        })}
                                                                    </div>
                                                                </div>
                                                            )}

                                                            <div className="flex gap-2 pt-3 border-t border-gray-100">
                                                                <Button
                                                                    size="sm"
                                                                    onClick={() => editFeature(item)}
                                                                    className="flex-1"
                                                                    style={{ backgroundColor: '#3b82f6', color: 'white' }}
                                                                >
                                                                    ✏️ ویرایش
                                                                </Button>
                                                                <Button
                                                                    size="sm"
                                                                    color="red"
                                                                    appearance="primary"
                                                                    onClick={() => deleteFeature(item._id)}
                                                                    className="flex-1"
                                                                >
                                                                    🗑️ حذف
                                                                </Button>
                                                            </div>
                                                        </div>
                                                    );
                                                })}
                                            </div>
                                        )}
                                    </div>
                                </div>
                            </Tabs.Tab>
                            <Tabs.Tab eventKey="4" title="سئو">
                                <div className="p-6" dir="rtl">
                                    {/* Language Selector */}
                                    <div className="mb-6 bg-gray-50 border border-gray-200 rounded-xl p-4">
                                        <label className="block text-sm font-medium text-gray-700 mb-3">
                                            زبان / Language
                                        </label>
                                        <div className="flex gap-2 flex-wrap">
                                            {languages.map((lang) => (
                                                <button
                                                    key={lang.code}
                                                    type="button"
                                                    onClick={() => setActiveLang(lang.code)}
                                                    className={`px-4 py-2 text-sm font-medium rounded-lg transition-all duration-200 ${activeLang === lang.code
                                                        ? 'bg-blue-600 text-white shadow-md scale-105'
                                                        : 'bg-white text-gray-700 hover:bg-gray-100 border border-gray-200'
                                                        }`}
                                                >
                                                    {lang.label}
                                                </button>
                                            ))}
                                        </div>
                                    </div>

                                    <div className="space-y-6">
                                        <div className="bg-gray-50 border border-gray-200 rounded-xl p-4">
                                            <h3 className="text-sm font-semibold text-gray-800 mb-4">اطلاعات SEO</h3>
                                            <div className="space-y-4">
                                                <div>
                                                    <label className="block text-sm font-medium text-gray-700 mb-2">
                                                        {t('تیتر')} ({languages.find(l => l.code === activeLang)?.label})
                                                    </label>
                                                    <Input
                                                        value={data.title?.[activeLang] || ''}
                                                        className={inputstyle}
                                                        onChange={(e) => setData({
                                                            ...data,
                                                            title: {
                                                                ...data.title,
                                                                [activeLang]: e
                                                            }
                                                        })}
                                                        placeholder="تیتر صفحه برای SEO"
                                                    />
                                                </div>

                                                <div>
                                                    <label className="block text-sm font-medium text-gray-700 mb-2">
                                                        {t('Description')} ({languages.find(l => l.code === activeLang)?.label})
                                                    </label>
                                                    <Input
                                                        as="textarea"
                                                        rows={3}
                                                        value={data.description?.[activeLang] || ''}
                                                        className={inputstyle}
                                                        onChange={(e) => setData({
                                                            ...data,
                                                            description: {
                                                                ...data.description,
                                                                [activeLang]: e
                                                            }
                                                        })}
                                                        placeholder="توضیحات متا برای SEO"
                                                    />
                                                </div>

                                                <div>
                                                    <label className="block text-sm font-medium text-gray-700 mb-2">
                                                        {t('Keywords')} ({languages.find(l => l.code === activeLang)?.label})
                                                    </label>
                                                    <Input
                                                        as="textarea"
                                                        rows={3}
                                                        value={data.keywords?.[activeLang] || ''}
                                                        className={inputstyle}
                                                        onChange={(e) => setData({
                                                            ...data,
                                                            keywords: {
                                                                ...data.keywords,
                                                                [activeLang]: e
                                                            }
                                                        })}
                                                        placeholder="کلمات کلیدی (با کاما جدا کنید)"
                                                    />
                                                </div>
                                            </div>
                                        </div>

                                        <div className="bg-gray-50 border border-gray-200 rounded-xl p-4">
                                            <h3 className="text-sm font-semibold text-gray-800 mb-4">اطلاعات اضافی</h3>
                                            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                                                <div>
                                                    <label className="block text-sm font-medium text-gray-700 mb-2">
                                                        {t('لیبل')}
                                                    </label>
                                                    <Input
                                                        value={data.label1 || ''}
                                                        className={inputstyle}
                                                        onChange={(e) => setData({ ...data, label1: e })}
                                                        placeholder="لیبل"
                                                    />
                                                </div>
                                                <div>
                                                    <label className="block text-sm font-medium text-gray-700 mb-2">
                                                        {t('دیتا')}
                                                    </label>
                                                    <Input
                                                        value={data.data1 || ''}
                                                        className={inputstyle}
                                                        onChange={(e) => setData({ ...data, data1: e })}
                                                        placeholder="دیتا"
                                                    />
                                                </div>
                                            </div>
                                        </div>

                                        <div className="flex justify-end pt-2 border-t border-gray-200">
                                            <Button
                                                appearance="primary"
                                                onClick={() => save()}
                                                disabled={saving}
                                                className="px-6"
                                            >
                                                {saving ? 'در حال ذخیره...' : 'ذخیره SEO'}
                                            </Button>
                                        </div>
                                    </div>
                                </div>
                            </Tabs.Tab>

                        </Tabs>
                    </div>
                </div>
            )}
        </div>
    )
}